// extracted by mini-css-extract-plugin
export default {"container":"AnimationBlock_container__QUtOk","animate":"AnimationBlock_animate__3+QbT"};